

import React, { useState, useEffect } from 'react';
import './AddRecipient.css';
// import '../../components/common/SubNavbar.css';
// import '../../components/common/CommonText.css';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { isRequired, isTextOnly } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "notificationcategory"

const NotificationCategory = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [items, setItems] = useState([]);
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const [popupError, setPopupError] = useState('');
  const navigate = useNavigate();
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Category"] || 0;

  useEffect(() => {
      fetchCategories();
      setFilters(pageKey, {
        searchParams,
        selectedFilterOption,
        selectedSortOption,
    });
  }, [searchParams, selectedFilterOption, selectedSortOption]);

  useEffect(() => {
    fetchCategories();
  }, [refreshKey]);

  const fetchCategories = async (id = null) => {
    try {
      const url = `${baseurl}notifications/category/`;
      const config = id
        ? { params: { id } }
        : {
            params: {
              search: searchParams.term,
              filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
              sort: mapSortOptionToQuery(selectedSortOption),
            },
          };
  
      const response = await authenticatedAxios.get(url, config);
  
      if (response?.data) {
        if (id) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(true);
        } else if (response.data.response_code === 1) {
          setItems(response.data.data);
        }
      } else {
        console.error("No data found for the selected category.");
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error("Error fetching categories:", error);
      }
    }
  };
  


  const handleAddCategory = async (formValues) => {
    try {
      const formData = new FormData();
      formData.append('name', formValues.name);
      
      if (formValues.icon instanceof File) {
        formData.append('icon', formValues.icon);
      } else if (formValues.icon && typeof formValues.icon === 'object' && formValues.icon.file) {
        // If the icon is an object with a file property
        formData.append('icon', formValues.icon.file);
      }
      
      formData.append('email_template', formValues.email_template);
  
      const response = await authenticatedAxios.post(`${baseurl}notifications/category/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.data.response_code === 1) {
        console.log('Category added successfully');
        await fetchCategories();
        setPopupError('');
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      console.error('Error adding Category:', error);
      setPopupError('Failed to add category. Please try again.');
    }
  };

  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}notifications/category/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchCategories();
        resetCheckboxState();
        setIsArchivePopupOpen(false);
      } 
    } catch (error) {
    }
  };

  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}notifications/category/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchCategories(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error deleting plan:', error);
    }
  };

  const handleArchive = async () => {
    try {
        const response = await authenticatedAxios.get(
            `${baseurl}notifications/category/archive/?id=${selectedItem.id}`
          );
      if (response.status >= 200 && response.status < 300) {
        setIsArchivePopupOpen(false); 
        fetchCategories(); 
        closePopups();
      } 
    } catch (error) {
      
    }
  };
  
  const handleEditCategory = async (formValues) => {
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}notifications/category/?id=${selectedItem.id}`,
        formValues,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      if (response.data.response_code === 1) {
        await fetchCategories();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to update category. Please try again.');
    }
  };
  
  
  
  const mapSortOptionToQuery = (option) => {
      switch (option) {
          case 'A-Z':
              return 'a_to_z';
          case 'Z-A':
              return 'z_to_a';
          case 'Newest':
              return 'newest';
          case 'Oldest':
              return 'oldest';
          default:
              return 'newest';
      }
  };

  const handleSortOptionSelect = (option) => {
      setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
      setSelectedFilterOption(option);
  };

  const handleSearchSelect = (searchTerm) => {
      setSearchParams({ term: searchTerm });
  };

  const handleEditClick = (item) => {
      setSelectedItem(item)
      setIsEditPopupOpen(true)
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };


  const handleNewClick = () => {
      setSelectedItem(null);
      setIsNewPopupOpen(true);
  };

  const handleDeleteClick = (item) => {
      setSelectedItem(item);
      setIsDeletePopupOpen(true);
  };

  const closePopups = () => {
      setIsEditPopupOpen(false);
      setIsArchivePopupOpen(false);
      setIsNewPopupOpen(false);
      setIsDeletePopupOpen(false);
      setSelectedItem([]);
      setPopupError('');
  };

  const addPopupFields = [
      { label: 'Category Name', name:'name', type: 'large-input',validators:[isTextOnly,isRequired]  },
      // { label: 'Select Email Template', name:'category', type: 'large-select', options:items,defaultValue: '',},
      { 
        label: 'Select Email Template', 
        name: 'email_template', 
        type: 'large-select', 
        options: [
            { label: 'Features Email', value: 'features_email.html' },
            { label: 'Offers Email', value: 'offers_email.html' }
        ], 
        defaultValue: '', 
        onChange: () => {}, validators: [isRequired] 
      },

      { label: 'Upload Icon', name:'icon',type: 'upload-box', validators: [isRequired]  },
  ];


  const deletePopupFields = [
      { label: 'Are you sure you want to delete this record? Once deleted, the data will be permanently removed.', type: 'text' },
  ];

  const editPopupFields = [
      { label: 'Category Name',name:'name', type: 'large-input', defaultValue: selectedItem?.name, onChange: () => {}, validators:[isRequired] },
      { 
        label: 'Select Email Template', 
        name: 'email_template', 
        type: 'large-select', 
        options: [
            { label: 'Features Email', value: 'features_email.html' },
            { label: 'Offers Email', value: 'offers_email.html' }
        ], 
        defaultValue: selectedItem?.email_template || '', 
        onChange: () => {} 
      },
      // { label: 'Upload Icon',name:'icon', type: 'upload-box', defaultValue:selectedItem?.icon },
      {
        label: 'Upload Icon',
        name: 'icon', 
        type: 'edit-upload-category',
        defaultValue: selectedItem ? `${baseurl.replace(/\/$/, '')}${selectedItem.icon}` : null
  
      },
  ];


  const handleExportComplete = () => {
    resetCheckboxState();
  };


  return (
      <div className='whole-container'>
          <div className='top-heading'>
              <PageHeader pageName=" Notifications /" nestedpageName="Notification Category"  linkTo="/notification-list" /> 

              <div className='export-container'>
                  <ArchiveSelectedItem
                    selectedItems={selectedItems}
                    items={items}
                    onArchiveSelected={handleArchiveSelectedItems}
                  />
                <ExportLabel
                  exportUrl={`${baseurl}notifications/category/export/`}
                  selectedIds={selectedItems}
                  onExportComplete={handleExportComplete}
                />
              </div>
          </div>
          <div className='pagename-container'>
              <div className='page-name'>
                  <h1 className='common-text fts-22 ftw-6 blue'>Notification Category</h1>
              </div>
              <div className='pagename-right-container'>
                  <AddButton onClick={handleNewClick} />
                  <SimpleSearchBox placeholder="Search Category" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
                  <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
                  <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
              </div>
          </div>
          {/* <div className='table-container'>
              <table className='common-table'>
                  <thead className='common-table-head'>
                  <tr className='common-table-thead-tr'>
                    <th>
                        <input
                          className="table-selectbox table-parent-selectbox"
                          type="checkbox"
                          checked={isParentSelected}
                          onChange={handleParentCheckboxChange}
                        />Category
                    </th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody className='common-table-tbody'>
                      {items.length > 0 ? (
                        items.map((category) => (
                          <tr key={category.id} className={`notification-tr ${category.is_archived ? 'archived-item' : ''}`}>
                            <td className='notification-td'>
                              <input
                                className="table-selectbox table-child-selectbox"
                                type="checkbox"
                                checked={selectedItems.includes(category.id)}
                                onChange={() => handleChildCheckboxChange(category.id)}
                              />
                              <img src={`${baseurl.replace(/\/$/, '')}${category.icon}`} alt={`${category.name} icon`} className="notification-category-icon" />                              
                              {category.name}
                            </td>
                            <td className="actions common-action">
                              <EditIcon onClick={() => handleEditClick(category)} />
                              <ArchiveIcon onClick={() => handleArchiveClick(category)} isArchived={category.is_archived}/>
                              <DeleteIcon onClick={() => handleDeleteClick(category)} />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">
                              No Notification Category Available
                          </td>
                        </tr>
                    )}
                  </tbody>
              </table>
          </div> */}
          <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Category
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
          {items.length > 0 ? (
            items.map((category) => (
              <tr key={category.id} className={category.is_archived ? 'archived-item' : ''}>
                <td >
                  <div className='d-flex ai-center'>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(category.id)}
                    onChange={() => handleChildCheckboxChange(category.id)}
                  />
                  <img src={`${baseurl.replace(/\/$/, '')}${category.icon}`} alt={`${category.name} icon`} className="notification-category-icon" />                              
                  {category.name}
                  </div>
                </td>
                <td className="actions common-action">
                  <EditIcon onClick={() => handleEditClick(category)} />
                  <ArchiveIcon onClick={() => handleArchiveClick(category)}  isArchived={category.is_archived} />
                  <DeleteIcon onClick={() => handleDeleteClick(category)} />
                </td>
              </tr>
            ))
          ):(
            <tr>
              <td colSpan="3">No Category Available</td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

          <EditPopup
              isOpen={isEditPopupOpen}
              title="Edit Notification Category"
              fields={editPopupFields}
              onSave={handleEditCategory}
              onClose={closePopups}
              popupErrorMessage={popupError}
          />
          <ArchivePopup
            isOpen={isArchivePopupOpen}
            isArchived={selectedItem?.is_archived}
            archivename={selectedItem?.name}
            onSave={handleArchive}
            onClose={() => setIsArchivePopupOpen(false)}
          />
          <AddPopup
              isOpen={isNewPopupOpen}
              title="New Notification Category"
              buttonName='Add Category'
              fields={addPopupFields}
              onSave={handleAddCategory}
              onClose={closePopups}
              popupErrorMessage={popupError}
          />
          <DeletePopup
            isOpen={isDeletePopupOpen}
            title="Delete Notification Category"
            fields={deletePopupFields}
            onSave={handleDelete}
            onClose={closePopups}
          />  
      </div>
  );
};

export default NotificationCategory;